export enum ChangeType {
  Add = 1,
  Edit = 2,
  Delete = 3,
  View = 4,
  Payment = 5
}
